import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { EndPointApi } from '@helpers/endpointapi';
import { ImportedExcelData } from 'icreate/common/models/channel-excel';

import { lastValueFrom } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ChannelExcelService {
    private domain: string;
    private headers: any = new HttpHeaders({
        'Content-Type': 'application/json',
    });

    constructor(private http: HttpClient) {
        this.domain = EndPointApi.iApiDomain();
    }

    importExcelFile(file, vesselId: string): Promise<ImportedExcelData> {
        const formData = new FormData();
        formData.append('file', file);
        formData.append('vesselId', vesselId);
        return lastValueFrom(this.http.post<ImportedExcelData>(`${this.domain}/api/excel/importFile`, formData));
    }

    importSimpleExcelFile(file, vesselId: string): Promise<ImportedExcelData> {
        const formData = new FormData();
        formData.append('file', file);
        formData.append('vesselId', vesselId);
        return lastValueFrom(this.http.post<ImportedExcelData>(`${this.domain}/api/excel/importFile/simple`, formData));
    }

    insertImportedData(vesselId: string, importedData: ImportedExcelData): Promise<any> {
        return lastValueFrom(this.http.post(`${this.domain}/api/excel/importData`, { vesselId, importedData }));
    }

    getExcelChannelRows(vesselId, groupId): Promise<any> {
        return lastValueFrom(
            this.http.get(`${this.domain}/api/excel/channels`, {
                headers: this.headers,
                params: { vesselId: vesselId, groupId: groupId },
            })
        );
    }

    updateChannels(vesselId, channelObj) {
        return lastValueFrom(
            this.http.put(`${this.domain}/api/excel/channels`, {
                headers: this.headers,
                params: { vesselId: vesselId, channelObj: channelObj },
            })
        );
    }

    downloadExcelFile(vesselId) {
        return lastValueFrom(
            this.http.get(`${this.domain}/api/excel/download/${vesselId}`, {
                responseType: 'blob',
            })
        );
    }

    downloadSimpleExcelFile(vesselId) {
        return lastValueFrom(
            this.http.get(`${this.domain}/api/excel/download/simple/${vesselId}`, {
                responseType: 'blob',
            })
        );
    }
}
